import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/runs");

export const Route = createFileRoute("/runs/")({
  head: () => ({
    meta: [
      { title: "Planning runs — LevelLoad" },
      { name: "description", content: "Planning runs — LevelLoad transport planning." },
      { property: "og:title", content: "Planning runs — LevelLoad" },
      { property: "og:description", content: "Planning runs — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
